import React from 'react';
import './footer.css';
import { FaHeart } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer>
      <div className='footer__container'>
        <p>
          Developed with{' '}
          <span>
            <FaHeart className='footer__icon' />
          </span>{' '}
          by Adan Perez
        </p>
      </div>
    </footer>
  );
};

export default Footer;
